var _circle, _g, _path, _g2, _g3, _rect, _rect2, _rect3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmpty(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 91,
    viewBox: "0 0 120 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 46,
    cy: 40,
    r: 38,
    fill: "#8372FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_5960_19692)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 33,
    width: 67,
    height: 52,
    rx: 6,
    fill: "url(#paint0_linear_5960_19692)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 28.1481V24C30 21.7909 31.7909 20 34 20H51.9814C53.1483 20 54.2571 20.5096 55.017 21.3952L59.6145 26.753C60.3744 27.6386 61.4832 28.1481 62.6501 28.1481H76.6916H99C101.209 28.1481 103 29.939 103 32.1481V71C103 73.2091 101.209 75 99 75H34C31.7909 75 30 73.2091 30 71V28.1481Z",
    fill: "url(#paint1_linear_5960_19692)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_5960_19692)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 57C18 55.8954 18.8954 55 20 55H56C57.1046 55 58 55.8954 58 57V80C58 81.1046 57.1046 82 56 82H20C18.8954 82 18 81.1046 18 80V57Z",
    fill: "#F1D3FF",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 82.5H56C57.3807 82.5 58.5 81.3807 58.5 80V57C58.5 55.6193 57.3807 54.5 56 54.5H20C18.6193 54.5 17.5 55.6193 17.5 57V80C17.5 81.3807 18.6193 82.5 20 82.5Z",
    stroke: "white",
    strokeOpacity: 0.3
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_b_5960_19692)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45 66.7679C46.3333 67.5377 46.3333 69.4623 45 70.2321L36.75 74.9952C35.4167 75.765 33.75 74.8027 33.75 73.2631L33.75 63.7369C33.75 62.1973 35.4167 61.235 36.75 62.0048L45 66.7679Z",
    fill: "#6D52B4"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 113.134,
    y: 19,
    width: 3,
    height: 9,
    rx: 1.5,
    transform: "rotate(46.9229 113.134 19)",
    fill: "#FFBB00"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 117.387,
    y: 30.2686,
    width: 3,
    height: 9,
    rx: 1.5,
    transform: "rotate(91.9229 117.387 30.2686)",
    fill: "#FFBB00"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 103.62,
    y: 14,
    width: 3,
    height: 9,
    rx: 1.5,
    transform: "rotate(16.9229 103.62 14)",
    fill: "#FFBB00"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_5960_19692",
    x: 27,
    y: 27,
    width: 79,
    height: 64,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_5960_19692"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_5960_19692",
    x: 9,
    y: 46,
    width: 58,
    height: 45,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_5960_19692"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_5960_19692",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_b_5960_19692",
    x: 25.75,
    y: 53.7339,
    width: 28.25,
    height: 29.5322,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_5960_19692"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_5960_19692",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5960_19692",
    x1: 66.5,
    y1: 33,
    x2: 66.5,
    y2: 83.7213,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9B8EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C82D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.744583,
    stopColor: "#8C82D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.80258,
    stopColor: "#8D82DA",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.967141,
    stopColor: "#978DE0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5960_19692",
    x1: 66.5,
    y1: 20,
    x2: 66.5,
    y2: 75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9B8EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8372FF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpty);
export default __webpack_public_path__ + "static/media/empty.795cf0a3.svg";
export { ForwardRef as ReactComponent };